export default abstract class SimpleFormat 
{
	public abstract message(level:string,...args:any[]):string|string[];
}

